// src/components/include/include.styles.ts
import { css } from "lit";
var include_styles_default = css`
  :host {
    display: block;
  }
`;

export {
  include_styles_default
};
